import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { TOKEN_KEY } from './api.js';

/*
|------------------------------------------------------------------------------
| Laravel Echo over Pusher protocol (Pusher or Soketi-compatible).
| Initialised once after login. Tear down on logout.
|------------------------------------------------------------------------------
*/

let echoInstance = null;

window.Pusher = Pusher;

export function initEcho() {
  if (echoInstance) return echoInstance;

  const host = import.meta.env.VITE_PUSHER_HOST;

  // No realtime host configured for this environment — skip init rather
  // than hammering wss://localhost:6001 and spamming the console with
  // failed WebSocket connections. Real-time features stay inert until
  // VITE_PUSHER_HOST is set; useEcho() already no-ops when getEcho()
  // returns null, so subscribers degrade gracefully.
  if (!host) return null;

  const token = localStorage.getItem(TOKEN_KEY);

  echoInstance = new Echo({
    broadcaster:    'pusher',
    key:            import.meta.env.VITE_PUSHER_APP_KEY      || 'nacis_key',
    cluster:        import.meta.env.VITE_PUSHER_APP_CLUSTER  || 'mt1',
    wsHost:         host,
    wsPort:    Number(import.meta.env.VITE_PUSHER_PORT       || 6001),
    wssPort:   Number(import.meta.env.VITE_PUSHER_PORT       || 6001),
    forceTLS:      (import.meta.env.VITE_PUSHER_SCHEME       || 'https') === 'https',
    enabledTransports: ['ws', 'wss'],
    authEndpoint:  (import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1').replace(/\/api\/v1\/?$/, '') + '/broadcasting/auth',
    auth: {
      headers: { Authorization: token ? `Bearer ${token}` : '' },
    },
  });

  return echoInstance;
}

export function getEcho() {
  return echoInstance;
}

export function tearDownEcho() {
  if (echoInstance) {
    try { echoInstance.disconnect(); } catch { /* ignore */ }
    echoInstance = null;
  }
}
